module.exports = __webpack_public_path__ + "media/images/emoticons/wrench-409f024c8b4c7f79fd5b03885cb71030.gif";